import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
export default {
  namespaced: true,
  state: () => ({
    chats: {}
  }),
  getters: {
    chats: state => {
      const chats = Object.values(state.chats) // .slice(0)
      chats.sort((a, b) => {
        if (!a.last_message) {
          return 1
        }
        if (!b.last_message) {
          return -1
        }
        if (a.last_message.created_at < b.last_message.created_at) {
          return 1
        }
        if (a.last_message.created_at > b.last_message.created_at) {
          return -1
        }
        return 0
      })
      return chats
    },
    clinicChats: state => {
      let chats = Object.values(state.chats) // .slice(0)
      chats = chats.filter(chat => {
        return chat.type === 'PatientClinic'
      })
      chats.sort((a, b) => {
        if (!a.last_message) {
          return 1
        }
        if (!b.last_message) {
          return -1
        }
        if (a.last_message.created_at < b.last_message.created_at) {
          return 1
        }
        if (a.last_message.created_at > b.last_message.created_at) {
          return -1
        }
        return 0
      })
      return chats
    },
    doctorChats: state => {
      let chats = Object.values(state.chats) // .slice(0)
      chats = chats.filter(chat => {
        return chat.type === 'PatientDoctor'
      })
      chats.sort((a, b) => {
        if (!a.last_message) {
          return 1
        }
        if (!b.last_message) {
          return -1
        }
        if (a.last_message.created_at < b.last_message.created_at) {
          return 1
        }
        if (a.last_message.created_at > b.last_message.created_at) {
          return -1
        }
        return 0
      })
      return chats
    },
    chatsWithDoctor: state => {
      const chats = Object.values(state.chats) // .slice(0)
      chats.sort((a, b) => {
        if (!a.last_message) {
          return 1
        }
        if (!b.last_message) {
          return -1
        }
        if (a.last_message.created_at < b.last_message.created_at) {
          return 1
        }
        if (a.last_message.created_at > b.last_message.created_at) {
          return -1
        }
        return 0
      })
      const ret = []
      for (const c of chats) {
        if (c.type === 'PatientDoctor') {
          ret.push(c)
        }
      }
      return ret
    },
    byId: state => id => state.chats[id],
    ByDoctor: state => id => {
      const chats = Object.values(state.chats)
      for (const chat of chats) {
        if (chat.chat_space.doctor_id === id) {
          return chat
        }
      }
      return null
    },
    ByClinic: state => id => {
      const chats = Object.values(state.chats)
      for (const chat of chats) {
        if (chat.chat_space.doctor_id === id) {
          return chat
        }
      }
      return null
    },
    isActive: state => id => {
      const chat = state.chats[id]
      if (chat === null) {
        return false
      }
      if (chat.type === 'DoctorClinic') {
        return true
      }
      if (chat.type === 'PatientDoctor') {
        if (chat.chat_space.active_until) {
          return moment(chat.chat_space.active_until).diff(moment()) > 0
        }
      } else if (chat.type === 'PatientClinic') {
        if (chat.chat_space.last_clinic_inquiry.status === 'completed') {
          return false
        }
      }
      return true
    }
  },
  mutations: {
    set (state, { chat_space, id, last_message, last_seen, type }) {
      if (!state.chats[id]) {
        Vue.set(state.chats, id, {})
      }
      Vue.set(state.chats[id], 'id', id)
      Vue.set(state.chats[id], 'chat_space', chat_space)
      Vue.set(state.chats[id], 'last_message', last_message)
      Vue.set(state.chats[id], 'last_seen', last_seen)
      Vue.set(state.chats[id], 'type', type)
    },
    reset (state) {
      Vue.set(state, 'chats', {})
    },
    replaceMessage (state, message) {
      const id = message.chat_space_id
      if (state.chats[id]) {
        Vue.set(state.chats[id], 'last_message', message)
      }
    },
    setInquiry (state, { id, inquiry }) {
      if (state.chats[id]) {
        const space = state.chats[id].chat_space
        space.last_clinic_inquiry = inquiry
        Vue.set(state.chats[id], 'chat_space', space)
      }
    },
    setlast_seen (state, { id, last_seen }) {
      if (state.chats[id]) {
        const chat = state.chats[id]
        chat.last_seen = last_seen
        Vue.set(state.chats, id, chat)
      }
    }
  },
  actions: {
    async fetchChat ({ commit }, id) {
      try {
        const response = await axios.get(`/api/chat-spaces/${id}`)
        const chat = response.data.data
        commit('set', {
          chat_space: chat.chat_space,
          id: chat.id,
          last_message: chat.last_message,
          last_seen: chat.last_seen,
          type: chat.type
        })
      } catch (err) {
        commit('alert/setError', err, { root: true })
      }
    },
    async seen ({ commit }, id) {
      try {
        const response = await axios.post(`/api/chat-spaces/${id}/seen`, {})
        const last_seen = response.data.data
        commit('setlast_seen', {
          id: id,
          last_seen: last_seen
        })
      } catch (err) {
        commit('alert/setError', err, { root: true })
      }
    },
    async send ({ commit }, { id, msg }) {
      try {
        const params = { text: msg }
        const response = await axios.post(
          `/api/chat-spaces/${id}/messages/text`,
          params
        )
        const messages = response.data.data
        commit('message/push', messages, { root: true })
      } catch (err) {
        console.log(err)
        commit('alert/setError', err, { root: true })
      }
    },
    async file ({ commit }, { id, msg, file }) {
      try {
        // const f = {}
        // id: UUID
        // chat_space_ID: UUID
        // name: string
        // mime_type: PatientCaseFileMimeType
        // created_at: DateTime
        // created_by: UUID
        // if (msg) {
        //   f.name = msg
        // } else {
        //   f.name = file.name
        // }
        // f.mime_type = file.type
        const formData = new FormData()
        formData.append('file', file)
        const response = await axios.post(
          `/api/chat-spaces/${id}/messages/file`,
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        )
        const messages = response.data.data
        console.log(messages)
        commit('message/push', messages, { root: true })
      } catch (err) {
        console.log(err)
        commit('alert/setError', err, { root: true })
      }
    }
  }
}
